import { useState, useEffect } from "react";

export const PasswordValidation = ({ password, policy }) => {
  console.log(" ==== inside policy password validation ");
  const [validLength, setValidLength] = useState(null);
  const [hasNumber, setHasNumber] = useState(null);
  const [upperCase, setUpperCase] = useState(null);
  const [lowerCase, setLowerCase] = useState(null);
  const [specialChar, setSpecialChar] = useState(null);
  const [mixedCase, setMixedCase] = useState(null);
  useEffect(() => {
    console.log("policy inside use effect", policy);
    setValidLength(password.length >= policy.min_length ? true : false);
    if (policy.mixedcase && policy.mixedcase) {
      console.log(" ==== policy inside mixed case ===== ");
      setLowerCase(/[a-z]/.test(password) ? true : false);
      setMixedCase(/(?=.*[a-z])(?=.*[A-Z])/.test(password) ? true : false);
      setUpperCase(/[A-Z]/.test(password) ? true : false);
    }
    if (policy.mixedcase && policy.mixedcase) {
      console.log(" ==== policy inside mixed case ===== 2");
      setUpperCase(/[A-Z]/.test(password) ? true : false);
    }
    if (policy.sp_char) {
      console.log(" ==== policy inside special character ===== ");
      if (password) {
        var format = /^[A-Za-z0-9]+$/;
        setSpecialChar(!format.test(password) ? true : false);
      }
    }
    if (policy.number) {
      console.log(" ==== policy inside number====");
      setHasNumber(/[0-9]/.test(password) ? true : false);
    }
  }, [password, policy]);
  console.log("mixedCase", mixedCase);
  console.log(
    ` ==== policy inside password validation ${validLength} ${hasNumber} ${upperCase} ${lowerCase} ${specialChar} ${mixedCase}`
  );
  return [validLength, hasNumber, upperCase, lowerCase, specialChar, mixedCase];
};
